import { AnomalySeverity, DashboardAnomaly } from '@vi-iot/client/index';
import { PillType } from 'src/app/shared/components/pill/pill.model';

export namespace DashboardAnomalyPillHelper {
  export interface AnomalyPill {
    pillType: PillType;
    label: string;
    tooltipText?: string;
  }

  export const AnomalySeveritySortValue = {
    [AnomalySeverity.RootCause]: 0,
    [AnomalySeverity.Critical]: 0,
    [AnomalySeverity.Warning]: 0,
    [AnomalySeverity.Information]: 1,
  };

  export function getAnomalyPillType(anomaly: DashboardAnomaly): PillType {
    let pillType: PillType = PillType.medium;
    if (anomaly.severity === AnomalySeverity.Information) {
      pillType = PillType.info;
    }

    return pillType;
  }
}
